// extracted by mini-css-extract-plugin
module.exports = {"container":"ResultItem_container__9l_7s","active":"ResultItem_active__VJO5N"};